<template>
    <div style="margin-top:15px;">    
        <el-form ref="form" :model="painspot_info" class="main_form" v-if="painspot_info.length > 0">
            <div v-if="ques_type=='C'">
                <div :key="index" v-for="(painspot, index) in painspot_info" style="width:100%;text-align:left;border:1.5px solid #e4e7ed;margin-bottom:5px;background:#f5f7fa;">
                    <p style="line-height:25px;font-size:15px;font-weight:bold;margin:5px;">{{ painspot.name }}</p>
                    <el-input
                        type="textarea"
                        resize="none"
                        :placeholder="phenomenon_desc"
                        :rows="3"
                        v-model="painspot.phenomenon"
                        style="margin:5px;"
                        :disabled="is_view">
                    </el-input>
                    <p style="line-height:25px;font-size:15px;margin:5px;">{{ select_causes_desc }}</p>
                    <!-- 下面的el-checkbox-group需要使用不同的v-model绑定，否则for循环中所有的el-checkbox-group会共享max的处理 -->
                    <el-checkbox-group v-model="painspot.selected_causes" :max="cause_analysis_maxnum">
                        <div style="text-align:left;width:100%;">
                            <el-checkbox :key="index" :disabled="is_view" v-for="(cause_analysis, index) in painspot.causeAnalysis" :label="cause_analysis" style="margin-left:5px;width:97%;"></el-checkbox>
                        </div>
                    </el-checkbox-group>
                    <el-input
                        type="textarea"
                        resize="none"
                        :placeholder="causeAnalysis_other_desc"
                        :rows="3"
                        v-model="painspot.other_cause"
                        v-show="/\d+.\d+、其他/.test(painspot.selected_causes.join('|'))"
                        style="margin:5px;"
                        :disabled="is_view">
                    </el-input>
                    <p style="line-height:25px;font-size:15px;margin:5px;">{{ done_measures_desc }}</p>
                    <el-input
                        type="textarea"
                        resize="none"
                        :rows="3"
                        v-model="painspot.done_measures"
                        style="margin:5px;"
                        :disabled="is_view">
                    </el-input>
                    <p style="line-height:25px;font-size:15px;margin:5px;">{{ expect_measures_desc }}</p>
                    <el-input
                        type="textarea"
                        resize="none"
                        :rows="3"
                        v-model="painspot.expect_measures"
                        style="margin:5px;"
                        :disabled="is_view">
                    </el-input>
                    <p style="line-height:25px;font-size:15px;margin:5px;">{{ future_measures_desc }}</p>
                    <el-input
                        type="textarea"
                        resize="none"
                        :rows="3"
                        v-model="painspot.future_measures"
                        style="margin:5px;"
                        :disabled="is_view">
                    </el-input>
                </div>
            </div>
            <el-checkbox-group v-model="selected_painspots" v-if="ques_type=='B' || ques_type=='D'">
                <div :key="index" v-for="(painspot, index) in painspot_info" style="width:100%;text-align:center;border:1.5px solid #e4e7ed;margin-bottom:5px;background:#f5f7fa;">
                    <div style="text-align:left;width:100%;">
                        <el-checkbox :label="painspot.name" :disabled="is_view" style="margin-left:5px;font-weight:bold;width:100%;"></el-checkbox>
                    </div>
                    <el-input
                        type="textarea"
                        resize="none"
                        :placeholder="phenomenon_desc"
                        :rows="3"
                        v-model="painspot.phenomenon"
                        v-show="selected_painspots.includes(painspot.name)"
                        style="margin:5px;"
                        :disabled="is_view">
                    </el-input>
                    <div v-if="ques_type=='D' && selected_painspots.includes(painspot.name)" style="text-align:left;width:100%;">
                        <p style="line-height:25px;font-size:15px;margin:5px;" v-if="painspot.name!='其他'">{{ select_causes_desc }}</p>
                    </div>
                    <el-checkbox-group v-model="painspot.selected_causes" v-if="ques_type=='D' && selected_painspots.includes(painspot.name)" :max="cause_analysis_maxnum">
                        <div style="text-align:left;width:100%;">
                            <el-checkbox :key="index" :disabled="is_view" v-for="(cause_analysis, index) in painspot.causeAnalysis" :label="cause_analysis" style="margin-left:5px;width:100%;"></el-checkbox>
                        </div>
                    </el-checkbox-group>
                    <!-- 这里使用正则来匹配其他选项，因为其前面有序号 -->
                    <el-input
                        type="textarea"
                        resize="none"
                        :placeholder="causeAnalysis_other_desc"
                        :rows="3"
                        v-model="painspot.other_cause"
                        v-show="/\d+.\d+、其他/.test(painspot.selected_causes.join('|')) && ques_type=='D'"
                        style="margin:5px;"
                        :disabled="is_view">
                    </el-input>
                    <div v-if="ques_type=='D' && selected_painspots.includes(painspot.name)" style="text-align:left;width:100%;">
                        <p style="line-height:25px;font-size:15px;margin:5px;">{{ done_measures_desc }}</p>
                    </div>
                    <el-input
                        type="textarea"
                        resize="none"
                        :rows="3"
                        v-model="painspot.done_measures"
                        v-if="ques_type=='D' && selected_painspots.includes(painspot.name)"
                        style="margin:5px;"
                        :disabled="is_view">
                    </el-input>
                    <div v-if="ques_type=='D' && selected_painspots.includes(painspot.name)" style="text-align:left;width:100%;">
                        <p style="line-height:25px;font-size:15px;margin:5px;">{{ expect_measures_desc }}</p>
                    </div>
                    <el-input
                        type="textarea"
                        resize="none"
                        :rows="3"
                        v-model="painspot.expect_measures"
                        v-if="ques_type=='D' && selected_painspots.includes(painspot.name)"
                        style="margin:5px;"
                        :disabled="is_view">
                    </el-input>
                    <div v-if="ques_type=='D' && selected_painspots.includes(painspot.name)" style="text-align:left;width:100%;">
                        <p style="line-height:25px;font-size:15px;margin:5px;">{{ future_measures_desc }}</p>
                    </div>
                    <el-input
                        type="textarea"
                        resize="none"
                        :rows="3"
                        v-model="painspot.future_measures"
                        v-if="ques_type=='D' && selected_painspots.includes(painspot.name)"
                        style="margin:5px;"
                        :disabled="is_view">
                    </el-input>
                </div>
            </el-checkbox-group>
        </el-form>
        <div v-if="display_flag===true" class="no_ques" v-cloak>暂无管理痛点相关信息，请先导入。</div>
    </div>
</template>

<script>
export default {
    // 组件传递的prop数据，会在beforeUpdate钩子期间生效！
    beforeUpdate() {
        if(this.sys_params.cause_analysis_maxnum==''){
            this.select_causes_desc = '您认为此痛点的原因是什么（请投票）';
            this.cause_analysis_maxnum = 1000;
        }else{
            this.select_causes_desc = '您认为此痛点的原因是什么（请投票，最多可选择' + this.sys_params.cause_analysis_maxnum + '个原因）'
            this.cause_analysis_maxnum = this.sys_params.cause_analysis_maxnum;
        }
    },
    data() {
        return {
            // selected_painspots: [],
            phenomenon_desc: '请详细描述此痛点在公司内的相关现象/表现，不少于100字。',
            causeAnalysis_other_desc: '请描述此痛点其他可能的成因。',
            cause_analysis_maxnum: 0,
            select_causes_desc: '',
            done_measures_desc: '为解决该痛点，您感受到公司已经采取了哪些措施？',
            expect_measures_desc: '您期待公司还能采取哪些措施解决该痛点？',
            future_measures_desc: '您认为作为管理者未来可以采取哪些措施来解决该痛点？',
        }
    },
    props: ['painspot_info', 'ques_type', 'sys_params', 'selected_painspots', 'is_view'],
    methods: {
        // 向父组件传递问卷测评结果（包括选择题和举证题两部分）
        submitManaQues() {
            // console.log('send data to father component.');
            this.$emit('sendData', [this.painspot_info, this.selected_painspots, this.ques_type]);
        },
    }
}
</script>

<style scoped>
::v-deep .el-checkbox__label {
    font-size: 15px;
    line-height: 25px;
}
::v-deep .el-textarea {
    display: block;
    width: auto;
}
</style>